<section class="content">
    <div class="content-block">
        <div class="row clearfix">
            <div class="col-lg-4 col-md-12">
                <div class="card">
                </div>
            </div>
            <div class="col-lg-12 col-md-12">
                <div class="card">


                    <div class="card-body p-2">

                        <div class="row">
                            <div class="col col-md-3">
                                <app-benef-info [beneficiaireAutOselect]="beneficiaireAutOselect">
                                    <app-search-form (sendUserInfo)="onSetUserInfo($event)"></app-search-form>
                                </app-benef-info>

                            </div>
                            <div class="col col-md-9">
                                <div class="container-fluid mt-1 mode-zone"
                                    style="position: relative; padding-bottom: 12px;" [ngClass]="{
                                        'mode-bg-prescription': currentMode === 'prescription',
                                        'mode-bg-renew': currentMode === 'renouvellement',
                                        'mode-bg-cmd': currentMode === 'commande'
                                    }">

                                    <div class="pharma-mode-bar mb-2">
                                        <div class="pharma-mode-btns">
                                            <button class="pharma-btn pharma-btn-prescription"
                                                [class.active]="currentMode === 'prescription'"
                                                [disabled]="!itemBeneficiare?.id"
                                                (click)="getItemsPrescriptionActe()">
                                                <i class="fas fa-file-prescription"></i>
                                                Prescriptions
                                            </button>
                                            <button class="pharma-btn pharma-btn-renew"
                                                [class.active]="currentMode === 'renouvellement'"
                                                [disabled]="!itemBeneficiare?.id"
                                                (click)="getItemsPrescriptionActeRenouvellement()">
                                                <span *ngIf="isLoadingRenew"
                                                    class="spinner-border spinner-border-sm"></span>
                                                <i *ngIf="!isLoadingRenew" class="fas fa-redo-alt"></i>
                                                Renouvellement
                                            </button>
                                            <button class="pharma-btn pharma-btn-cmd"
                                                [class.active]="currentMode === 'commande'"
                                                [disabled]="!itemBeneficiare?.id"
                                                (click)="getItemsCommandeMedicament()">
                                                <span *ngIf="isLoadingCommande"
                                                    class="spinner-border spinner-border-sm"></span>
                                                <i *ngIf="!isLoadingCommande" class="fas fa-shopping-cart"></i>
                                                Commandes
                                            </button>
                                        </div>
                                        <div class="pharma-mode-label">
                                            <span *ngIf="currentMode === 'prescription'"
                                                class="mode-tag mode-prescription">
                                                <i class="fas fa-file-prescription me-1"></i>Prescriptions actives
                                            </span>
                                            <span *ngIf="currentMode === 'renouvellement'" class="mode-tag mode-renew">
                                                <i class="fas fa-redo-alt me-1"></i>Renouvellements —
                                                <strong>{{ itemBeneficiare?.nom }} {{ itemBeneficiare?.prenom
                                                    }}</strong>
                                            </span>
                                            <span *ngIf="currentMode === 'commande'" class="mode-tag mode-cmd">
                                                <i class="fas fa-shopping-cart me-1"></i>Commandes patients
                                            </span>
                                        </div>
                                    </div>

                                    <div class="aservir-header">
                                        <span class="aservir-title">
                                            <i class="fas fa-pills me-1"></i>Médicaments à servir
                                        </span>
                                        <span class="aservir-count" *ngIf="itemsMedicamentAservir?.length">
                                            {{ itemsMedicamentAservir.length }} article(s)
                                        </span>
                                    </div>

                                    <div class="table-responsive">
                                        <table class="table table-sm table-hover aservir-table mb-0">
                                            <thead>
                                                <tr>
                                                    <th style="width:22px;" class="text-center">#</th>
                                                    <th>Produit</th>
                                                    <th style="width:80px;" class="text-end">Prix sys.</th>
                                                    <th style="width:68px;" class="text-center">Qté</th>
                                                    <th style="width:88px;" class="text-end">Prix</th>
                                                    <th style="width:80px;" class="text-end">Montant</th>
                                                    <th style="width:68px;" class="text-end">TM</th>
                                                    <th style="width:68px;" class="text-end">REMB</th>
                                                    <th style="width:58px;"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <!-- Skeleton -->
                                                <ng-container *ngIf="!itemBeneficiare?.id">
                                                    <tr *ngFor="let s of [1,2]" class="skel-row">
                                                        <td><span class="skel-cell" style="width:20px"></span></td>
                                                        <td><span class="skel-cell" style="width:65%"></span></td>
                                                        <td><span class="skel-cell" style="width:50px;margin-left:auto"></span></td>
                                                        <td><span class="skel-cell" style="width:40px;margin:0 auto"></span></td>
                                                        <td><span class="skel-cell" style="width:40px"></span></td>
                                                        <td><span class="skel-cell" style="width:50px;margin-left:auto"></span></td>
                                                        <td><span class="skel-cell" style="width:40px;margin-left:auto"></span></td>
                                                        <td><span class="skel-cell" style="width:40px;margin-left:auto"></span></td>
                                                        <td><span class="skel-cell" style="width:30px;margin:0 auto"></span></td>
                                                    </tr>
                                                </ng-container>
                                                <!-- Données groupées par ordonnance -->
                                                <ng-container *ngIf="itemBeneficiare?.id">
                                                <ng-container *ngFor="let group of groupedAservirList">
                                                    <tr class="ordonnance-group-header">
                                                        <td colspan="9">
                                                            <i class="fas fa-file-prescription me-1"></i>
                                                            <strong>Ordonnance : {{ group.key }}</strong>
                                                            <span class="ms-2 text-muted" style="font-size:11px;">({{ group.items.length }} méd.)</span>
                                                        </td>
                                                    </tr>
                                                <tr *ngFor="let item of group.items; let indice=index"
                                                    [ngClass]="{
                                                        'option-background-orange': item.is_entente_prealable,
                                                        'option-background-red': item.is_exclu,
                                                        'option-background-green': !item.is_exclu && !item.is_entente_prealable,
                                                        'medoc-replacer': item.is_replacer
                                                    }">
                                                    <td class="text-center text-muted">{{ indice+1 }}</td>
                                                    <td>
                                                        <span *ngIf="item.forme_medicament_libelle"
                                                            class="pharma-forme-tag">{{ item.forme_medicament_libelle }}</span>
                                                        {{ item.medicament_libelle }}
                                                    </td>
                                                    <td class="text-end">{{ item.prix_systeme | IntegerFormatPipe }}
                                                    </td>
                                                    <td>
                                                        <input [disabled]="item.is_entente_prealable || !canServirMedocEnDetail"
                                                            type="text" mask="separator"
                                                            class="form-control form-control-sm text-center"
                                                            [(ngModel)]="item.quantite_pharmacie"
                                                            [ngModelOptions]="{standalone:true}"
                                                            (input)="calculateTotalPartiel(item)"
                                                            [title]="!canServirMedocEnDetail ? 'Vente en détail non autorisée' : 'Maximum: '+(currentMode==='renouvellement' ? item.quantite_renew : item.quantite)">
                                                    </td>
                                                    <td>
                                                        <input [disabled]="item.is_entente_prealable"
                                                            type="text" mask="separator"
                                                            class="form-control form-control-sm text-end"
                                                            [(ngModel)]="item.prix_pharmacie"
                                                            [ngModelOptions]="{standalone:true}"
                                                            (input)="calculateTotalPartiel(item)">
                                                    </td>
                                                    <td class="text-end fw-semibold">{{ (item.montant||0) |
                                                        IntegerFormatPipe }}</td>
                                                    <td class="text-end text-warning fw-semibold">{{
                                                        (item.part_patient||0) | IntegerFormatPipe }}</td>
                                                    <td class="text-end text-success fw-semibold">{{
                                                        (item.part_assurance||0) | IntegerFormatPipe }}</td>
                                                    <td class="text-center">
                                                        <div class="d-flex gap-1 justify-content-center">
                                                            <button (click)="selectedDetailItem = item; $event.stopPropagation()"
                                                                class="btn btn-outline-info btn-xs" title="Détail">
                                                                <i class="fas fa-info-circle"></i>
                                                            </button>
                                                            <button *ngIf="canSubstitute(item)"
                                                                (click)="openSubstitutionModal(item)"
                                                                class="btn btn-outline-warning btn-xs" title="Substituer">
                                                                <i class="fas fa-exchange-alt"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </ng-container><!-- fin *ngFor groupedAservirList -->
                                                <!-- Ligne totaux -->
                                                <tr class="aservir-total-row" *ngIf="itemsMedicamentAservir?.length">
                                                    <td colspan="5" class="text-end fw-bold">Total</td>
                                                    <td class="text-end fw-bold">{{ getTotal() | IntegerFormatPipe }}
                                                    </td>
                                                    <td class="text-end text-warning fw-bold">{{ getTotalPartPatient() |
                                                        IntegerFormatPipe }}</td>
                                                    <td class="text-end text-success fw-bold">{{ getTotalPartAssurance()
                                                        | IntegerFormatPipe }}</td>
                                                    <td></td>
                                                </tr>
                                                <tr *ngIf="!itemsMedicamentAservir?.length">
                                                    <td colspan="9" class="text-center text-muted py-3">
                                                        <i class="fas fa-info-circle me-2"></i>Aucun médicament ajouté
                                                    </td>
                                                </tr>
                                                </ng-container>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- </div> -->


                                    <div class="row mt-2">
                                        <div class="col-md-12"
                                            *ngIf="itemToSave.montant_depassement && itemToSave.montant_depassement>0">
                                            <div class="alert alert-danger text-center font-weight-bold shadow-lg p-4 rounded"
                                                style="font-size: 1.2rem; border: 2px solid #dc3545;">

                                                <!-- ⚠️ Il y a un dépassement de <strong>{{itemToSave.montant_depassement | IntegerFormatPipe}} FCFA</strong>.
                    Ce montant est à la charge du patient. -->
                                                ⚠️ {{itemToSave.message_depassement}}

                                                <hr class="my-3" style="border-color: #fff;">

                                                <div class="text-left" style="font-size: 1rem;">
                                                    <p><strong>Nouveaux montants :</strong></p>
                                                    <p>💰 Part patient : <span class="text-danger"
                                                            style="font-weight: 700;">{{itemToSave.part_patient |
                                                            IntegerFormatPipe}}
                                                            FCFA</span></p>
                                                    <p>🏥 Part assurance : <span class="text-success"
                                                            style="font-weight: 700;">{{itemToSave.part_assurance |
                                                            IntegerFormatPipe}} FCFA
                                                            FCFA</span></p>
                                                </div>

                                                <div class="mt-3">
                                                    <button (click)="confirmSaveItem(itemToSave)"
                                                        class="btn btn-outline-light btn-lg shadow-sm"
                                                        style="font-weight:bold; background:gray">
                                                        ✅ Souhaitez-vous continuer ?
                                                    </button>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="col-12">
                                            <button [disabled]="!itemBeneficiare?.id || !itemsMedicament.length" (click)="onMedocDeepSeek()"
                                                class="btn btn-primary btn-sm w-100">
                                                Soumettre vente
                                            </button>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>


                    <div class="my-modal-overlay" *ngIf="showModal">
                        <div class="my-modal subst-modal">
                            <div class="my-modal-header">
                                <span><i class="fas fa-exchange-alt me-2"></i>Substitution de médicament</span>
                                <button (click)="showModal = false" class="my-close-btn">&times;</button>
                            </div>
                            <div class="my-modal-body">

                                <!-- Médicament original — carte compacte -->
                                <div class="subst-original-card">
                                    <div class="subst-original-label">
                                        <i class="fas fa-pills me-1"></i> Médicament original
                                    </div>
                                    <div class="subst-original-info">
                                        <span class="subst-info-name">
                                            <span *ngIf="medocOriginal.forme_medicament_libelle" class="pharma-forme-tag me-1">{{ medocOriginal.forme_medicament_libelle }}</span>
                                            <strong>{{ medocOriginal.medicament_libelle }}</strong>
                                        </span>
                                        <span class="subst-info-chip"><i class="fas fa-sort-amount-up me-1"></i>Qté : <strong>{{ medocOriginal.quantite }}</strong></span>
                                        <span class="subst-info-chip"><i class="fas fa-clock me-1"></i>Durée : <strong>{{ medocOriginal.duree }} j</strong></span>
                                        <span class="subst-info-chip"><i class="fas fa-tag me-1"></i>Prix sys. : <strong>{{ medocOriginal.prix_systeme | IntegerFormatPipe }} F</strong></span>
                                    </div>
                                    <div *ngIf="medocOriginal.posologie" class="subst-posologie">
                                        <i class="fas fa-info-circle me-1 text-muted"></i>{{ medocOriginal.posologie }}
                                    </div>
                                </div>

                                <!-- Formulaire substitut -->
                                <div class="subst-form-section">
                                    <div class="subst-form-title"><i class="fas fa-arrow-right me-1"></i>Médicament de substitution</div>
                                    <div class="row g-2 align-items-end">
                                        <div class="col-md-5">
                                            <label class="form-label form-label-sm">Rechercher un médicament</label>
                                            <app-search-mdicament-pro [cancelItemSelected]="cancelItemSelected"
                                                [showPrice]="'true'" [is_garanti]="'true'"
                                                (itemMedicamentSelected)="onSelectMedocPro($event)">
                                            </app-search-mdicament-pro>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="form-label form-label-sm">Forme</label>
                                            <input disabled type="text" class="form-control form-control-sm"
                                                [(ngModel)]="selectedMedoc.forme_medicament_libelle"
                                                name="forme_medicament_libelle" placeholder="—">
                                        </div>
                                        <div class="col-md-1">
                                            <label class="form-label form-label-sm">Qté</label>
                                            <input disabled mask="separator" type="text"
                                                class="form-control form-control-sm text-center"
                                                [(ngModel)]="itemToAdd.quantite" name="quantite">
                                        </div>
                                        <div class="col-md-2">
                                            <label class="form-label form-label-sm">Prix sys. (F)</label>
                                            <input disabled mask="separator" type="text"
                                                class="form-control form-control-sm text-end"
                                                [(ngModel)]="itemToAdd.prix" name="prix">
                                        </div>
                                        <div class="col-md-2">
                                            <label class="form-label form-label-sm">Posologie</label>
                                            <input type="text" class="form-control form-control-sm"
                                                [(ngModel)]="itemToAdd.posologie" name="posologie"
                                                placeholder="ex: 1cp matin">
                                        </div>
                                        <div class="col-md-1">
                                            <label class="form-label form-label-sm">Durée (j)</label>
                                            <input mask="separator" type="text"
                                                class="form-control form-control-sm text-center"
                                                [(ngModel)]="itemToAdd.duree" name="duree">
                                        </div>
                                        <div class="col-md-1">
                                            <button (click)="addMedicament()" type="button"
                                                class="btn btn-primary btn-sm w-100">
                                                <i class="fas fa-check"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="my-modal-footer">
                                <button (click)="showModal = false" class="btn btn-outline-secondary btn-sm">
                                    <i class="fas fa-times me-1"></i>Fermer
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- Popup détail médicament -->
    <div class="pharma-overlay" *ngIf="selectedDetailItem" (click)="selectedDetailItem = null">
        <div class="pharma-popup" (click)="$event.stopPropagation()">
            <div class="pharma-popup-header">
                <span><i class="fas fa-pills me-2"></i>Détail médicament</span>
                <button (click)="selectedDetailItem = null">&times;</button>
            </div>
            <div class="pharma-popup-body">
                <div class="pharma-detail-title">
                    <span *ngIf="selectedDetailItem.forme_medicament_libelle" class="pharma-forme-tag">{{
                        selectedDetailItem.forme_medicament_libelle }}</span>
                    <strong>{{ selectedDetailItem.medicament_libelle }}</strong>
                </div>
                <div class="pharma-detail-grid">
                    <div class="pharma-detail-field">
                        <label>Ordonnance</label>
                        <span>{{ selectedDetailItem.ordonnance_codification || '—' }}</span>
                    </div>
                    <div class="pharma-detail-field">
                        <label>Acte</label>
                        <span>{{ selectedDetailItem.prestation_acte_libelle || '—' }}</span>
                    </div>
                    <div class="pharma-detail-field">
                        <label>Affection</label>
                        <span>{{ selectedDetailItem.affection_libelle || '—' }}</span>
                    </div>
                    <div class="pharma-detail-field">
                        <label>Posologie</label>
                        <span>{{ selectedDetailItem.posologie || '—' }}</span>
                    </div>
                    <div class="pharma-detail-field">
                        <label>Durée</label>
                        <span>{{ selectedDetailItem.duree || '—' }} jr(s)</span>
                    </div>
                    <div class="pharma-detail-field">
                        <label>Quantité</label>
                        <span>{{ selectedDetailItem.quantite || '—' }}</span>
                    </div>
                    <div class="pharma-detail-field">
                        <label>Prix système</label>
                        <span>{{ selectedDetailItem.prix_systeme || '—' }} FCFA</span>
                    </div>
                    <div class="pharma-detail-field">
                        <label>Renouvellement</label>
                        <span [class.text-success]="selectedDetailItem.is_renewable"
                            [class.text-danger]="!selectedDetailItem.is_renewable">
                            {{ selectedDetailItem.is_renewable ? 'Oui' : 'Non' }}
                        </span>
                    </div>
                    <div class="pharma-detail-field" *ngIf="selectedDetailItem.is_renewable">
                        <label>Fréquence ren. (jr)</label>
                        <span>{{ selectedDetailItem.frequence_renew || '—' }}</span>
                    </div>
                    <div class="pharma-detail-field" *ngIf="selectedDetailItem.is_renewable">
                        <label>Durée ren. (jr)</label>
                        <span>{{ selectedDetailItem.duree_renew || '—' }}</span>
                    </div>
                    <div class="pharma-detail-field" *ngIf="selectedDetailItem.is_renewable">
                        <label>Qté ren.</label>
                        <span>{{ selectedDetailItem.quantite_renew || '—' }}</span>
                    </div>
                    <div class="pharma-detail-field">
                        <label>Statut</label>
                        <span class="badge"
                            [class.bg-success]="!selectedDetailItem.is_exclu && !selectedDetailItem.is_entente_prealable"
                            [class.bg-warning]="selectedDetailItem.is_entente_prealable"
                            [class.bg-danger]="selectedDetailItem.is_exclu">
                            {{ selectedDetailItem.is_exclu ? 'Non garanti' : selectedDetailItem.is_entente_prealable ?
                            'Entente préalable' : 'Garanti' }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>